import { safeNavigate } from '@/utils/safeUrl';

export const getDefaultState = () => ({
  refUrl: null,
  redirectTime: null,
  retryableErrorCodes: null,
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  SET: 'SET',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
  },

  [types.SET](state, data) {
    state.refUrl = data.refUrl;
    state.redirectTime = data.redirectTime;
    state.retryableErrorCodes = data.retryableErrorCodes;
  },
};

export const getters = {};

export const actions = {
  set({ commit }, data) {
    commit(types.SET, data);
  },

  redirect({ state }) {
    // SECURITY: safeNavigate refuses non-http(s) URLs (blocks javascript:/data: XSS).
    safeNavigate(state.refUrl);
  },
};
